import * as React from 'react'

interface Props<T> {
  name: string
  className?: string
  innerClassName?: string
  choices: { value: T, text: string | React.ReactNode, tooltip?: string | React.ReactNode, disabled?: boolean, tooltipWarning?: string }[]
  value: T
  style?: React.CSSProperties
  innerStyle?: React.CSSProperties
  onChange: (value: T) => void
}

export default function RadioGroupComponent<T> ({ choices, value, name, className, innerClassName, style, innerStyle, onChange }: Props<T>) {
  return <div className={ className } style={ style }>
    { choices.map((choice, index) => <div key={ index } className={ `inputRadio ${innerClassName}` } style={ innerStyle }>
      <input type="radio" checked={ value === choice.value } id={ `radio-group-${name}-${index}` } data-value={ String(choice.value) } onChange={ () => !choice.disabled && onChange(choice.value) } disabled={ choice.disabled } />
      <label htmlFor={ `radio-group-${name}-${index}` }>{ choice.text }</label>

      { choice.tooltipWarning && <div className={ `inputRadio-message u-mbs u-txtClr2` }>{ choice.tooltipWarning }</div> }
      { choice.tooltip && <div className="inputRadio-message u-mbm">{ choice.tooltip }</div> }
    </div>) }
  </div>
}
